import { RequestMethodEnum } from "../../../common/modules/httpClient/enums/RequestMethodEnum";
import { useHttpClientDispatchableOnly } from "../../../common/modules/httpClient/hooks/useHttpClientDispatchableOnly";

export const useManageRoleMapService = () =>
  useHttpClientDispatchableOnly({
    url: "/team/roleMap",
    method: RequestMethodEnum.PATCH,
  });
